var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1875 15C27.1875 15.3405 27.0029 15.6542 26.7053 15.8195L23.8524 17.4045C18.2131 20.5374 12.2684 23.0858 6.11099 25.01L5.27963 25.2698C4.99497 25.3588 4.68497 25.307 4.44468 25.1303C4.2044 24.9537 4.0625 24.6732 4.0625 24.375L4.0625 17.1875C4.0625 16.6987 4.43802 16.292 4.92524 16.253L5.2094 16.2303C7.89872 16.0151 10.5673 15.6036 13.194 14.9996C10.5305 14.3872 7.82377 13.9728 5.09613 13.7603L4.92719 13.7472C4.43914 13.7092 4.0625 13.302 4.0625 12.8125L4.0625 5.62501C4.0625 5.32677 4.2044 5.04633 4.44468 4.86967C4.68497 4.69302 4.99497 4.64123 5.27963 4.73018L6.11098 4.98998C12.2684 6.91418 18.2131 9.4626 23.8524 12.5955L26.7053 14.1805C27.0029 14.3458 27.1875 14.6595 27.1875 15ZM24.3196 15L22.9418 14.2346C17.5321 11.2292 11.8356 8.77251 5.9375 6.90111L5.9375 11.9495C9.6001 12.2798 13.2229 12.9627 16.7554 13.989L17.1366 14.0997C17.5374 14.2162 17.8129 14.5835 17.8125 15.0009C17.8121 15.4183 17.5358 15.7851 17.1348 15.9008L16.6466 16.0416C13.1485 17.0505 9.56254 17.723 5.9375 18.05L5.9375 23.0989C11.8356 21.2275 17.532 18.7709 22.9418 15.7654L24.3196 15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSend);
export default __webpack_public_path__ + "static/media/icon_send.a28d47fa612a12a6ab13d7b7ce6a7a2d.svg";
export { ForwardRef as ReactComponent };